import { useCallback, useEffect, useRef } from 'react';
import { useActiveTheme } from 'shared/lib/mui';
import { collectMetadata } from 'shared/services/featurebase/metadata-collector';
import { ThemeModes } from 'shared/types/theme-modes';

import { useFeaturebaseScript } from './use-featurebase-script';

const defaultBoardName = '🐞 Bugs';

export const useFeaturebaseWidget = (token?: string) => {
  const { isReady, isError } = useFeaturebaseScript();
  const [activeTheme] = useActiveTheme();

  const lastTokenRef = useRef<string | null>(null);

  const openWidget = useCallback(() => {
    window.postMessage(
      {
        target: 'FeaturebaseWidget',
        data: { action: 'openFeedbackWidget', setBoard: defaultBoardName },
      },
      '*',
    );
  }, []);

  // Pre-initialize widget as soon as token + SDK are available
  useEffect(() => {
    if (!isReady || isError || !token) {
      return;
    }

    if (lastTokenRef.current === token) {
      return;
    }

    if (window.Featurebase) {
      const metadata = collectMetadata();

      window.Featurebase('initialize_feedback_widget', {
        organization: 'griply',
        theme: activeTheme === ThemeModes.Dark ? 'dark' : 'light',
        defaultBoard: defaultBoardName,
        locale: 'en',
        metadata,
        featurebaseJwt: token,
      });

      lastTokenRef.current = token;
    }
  }, [isReady, isError, token, activeTheme]);

  return {
    openWidget,
    isReady,
  };
};
